// Storage keys — the ONLY place these string names live. Everything that reads or
// writes auth state does so through session.ts, which imports from here.
export const AUTH_TOKEN_KEY = 'oubo_admin_token';
export const REFRESH_TOKEN_KEY = 'oubo_admin_refresh_token';
export const USER_KEY = 'oubo_auth_user';

// Window events bridged from the (non-React) axios layer to the React tree. The
// API client can't call hooks/navigate, so it emits these and AuthProvider reacts.
export const AUTH_SESSION_EXPIRED_EVENT = 'auth:session-expired';
export const AUTH_FORBIDDEN_EVENT = 'auth:forbidden';